import React, { useState, useEffect } from "react";

import icons from "../../../../constants/icons";
import * as IconsSVG from "../../../../assets/iconsSVG";
import * as Styles from "../../styles";

interface Props {
  nome: string;
  idLeadCorretor: string;
  idLead: string;
  email1: string;
  email2: string;
  email3: string;
  telefone1: string;
  telefone2: string;
  telefone3: string;
  codigoCargo2013: string | null;
}

const CardBirthday: React.FC<Props> = ({
  nome,
  codigoCargo2013,
  email1,
  email2,
  email3,
  telefone1,
  telefone2,
  telefone3,
  idLead,
}) => {
  const [phone, setPhone] = useState<string>("");
  const [formatedPhone, setFormatedPhone] = useState<string>("");
  const [mail, setMail] = useState<string>("");

  useEffect(() => {
    if (telefone3) {
      setPhone(telefone3);
      setFormatedPhone(formatPhoneNumber(telefone3));
    }
    if (telefone2) {
      setPhone(telefone2);
      setFormatedPhone(formatPhoneNumber(telefone2));
    }
    if (telefone1) {
      setPhone(telefone1);
      setFormatedPhone(formatPhoneNumber(telefone1));
    }
    if (email3) {
      setMail(email3);
    }
    if (email2) {
      setMail(email2);
    }
    if (email1) {
      setMail(email1);
    }
  }, []);

  const formatPhoneNumber = (str: string) => {
    const match: any =
      str.match(/^(\d{2})(\d{2})(\d{5})(\d{4})$/) ||
      str.match(/^(\d{2})(\d{2})(\d{4})(\d{4})$/) ||
      str.match(/^(\d{3})(\d{3})(\d{3})(\d{3})(\d{3})$/) ||
      str.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/) ||
      str.match(/^(\d{2})(\d{3})(\d{3})(\d{3})(\d{1})$/);

    if (match && match.length <= 5) {
      return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`;
    }
    if (match && match.length > 5) {
      return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}-${match[5]}`;
    }

    return str;
  };
  return (
    <Styles.CardBirthday
      href={
        codigoCargo2013 === "219.840.002"
          ? `/leads/${idLead}`
          : `/leads-detail/${idLead}`
      }
    >
      <Styles.HeaderCardBD>
        <Styles.TitleBday>Aniversário</Styles.TitleBday> <IconsSVG.BDayBaloon />
      </Styles.HeaderCardBD>
      <Styles.TextCardBD>Hoje é aniversário de {nome}</Styles.TextCardBD>
      <Styles.Row>
        {formatedPhone && (
          <Styles.ContactText
            style={{ marginRight: 16 }}
            href={`https://wa.me/${phone}?text=Caro%20${nome},%0D%0AFeliz%20anivers%C3%A1rio!%20Desejamos%20a%20voc%C3%AA%20um%20dia%20especial%20e%20cheio%20de%20alegria.%20Esperamos%20que%20este%20novo%20ano%20traga%20muitas%20oportunidades%20e%20sucesso%20em%20sua%20vida.%0D%0A%0D%0AParab%C3%A9ns!%0D%0A%0D%0AAtenciosamente,%0D%0AEquipe%20Cyrela`}
            target="_blank"
          >
            <IconsSVG.BdayWppIcon /> {formatedPhone}
          </Styles.ContactText>
        )}
        {mail && (
          <Styles.ContactText href={`mailto: ${mail}`} target="_blank">
            <img src={icons.outlookIcon} alt="Outlook icon" /> {mail}
          </Styles.ContactText>
        )}
      </Styles.Row>
    </Styles.CardBirthday>
  );
};

export default CardBirthday;
